import type { SortDirection, TaskSort, Todo } from "../../domain/entities.ts";
import { compareTaskOrder } from "./productivity.ts";

export function normalizeTaskSort(value?: string): TaskSort {
  if (value === "newest" || value === "oldest") return "created";
  return ["manual", "title", "created", "due", "priority", "status"].includes(value || "") ? value as TaskSort : "manual";
}

export function normalizeSortDirection(value?: string, legacySort?: string): SortDirection {
  return value === "desc" || legacySort === "newest" ? "desc" : "asc";
}

export function normalizePageSize(value?: number): number {
  return [10, 25, 50, 100].includes(Number(value)) ? Number(value) : 0;
}

export function taskOrder(left: Todo, right: Todo): number {
  return compareTaskOrder(left, right);
}

export function compareTasks(left: Todo, right: Todo, sortBy: TaskSort, direction: SortDirection): number {
  const pinned = Number(!!right.pinned) - Number(!!left.pinned);
  if (pinned) return pinned;
  const multiplier = direction === "desc" ? -1 : 1;
  if (sortBy === "title") return multiplier * (left.title || "").localeCompare(right.title || "", undefined, { sensitivity: "base" }) || taskOrder(left, right);
  if (sortBy === "created") return multiplier * (left.createdAt - right.createdAt) || taskOrder(left, right);
  if (sortBy === "due") {
    if (!left.dueDate || !right.dueDate) return left.dueDate ? -1 : right.dueDate ? 1 : taskOrder(left, right);
    return multiplier * left.dueDate.localeCompare(right.dueDate) || taskOrder(left, right);
  }
  if (sortBy === "priority") return multiplier * (priorityRank(left.priority) - priorityRank(right.priority)) || taskOrder(left, right);
  if (sortBy === "status") return multiplier * (Number(left.completed) - Number(right.completed)) || taskOrder(left, right);
  return taskOrder(left, right);
}

export function activeTags(todo: Todo): string[] {
  const active = new Set(Object.keys(todo.tags || {}).filter(tag => todo.tags[tag]));
  return [...(todo.tagOrder || []).filter(tag => active.delete(tag)), ...active];
}

function priorityRank(priority: Todo["priority"]): number {
  return ({ none: 0, low: 1, medium: 2, high: 3, urgent: 4 })[priority];
}
